import { FC, ReactNode } from 'react';
import Typography from '@mui/material/Typography';
import Section from './Section';

interface Props {
  eyebrow: string;
  title: string;
  subtitle?: ReactNode;
  align?: 'left' | 'center';
  /** Defaults to Section's content width */
  maxWidth?: number;
  subtitleMaxWidth?: number;
  /** Optional CTA rendered below the subtitle */
  children?: ReactNode;
}

const PageHero: FC<Props> = ({
  eyebrow,
  title,
  subtitle,
  align = 'left',
  maxWidth,
  subtitleMaxWidth,
  children,
}) => {
  const centered = align === 'center';

  return (
    <Section
      bandSx={{
        background: theme => theme.palette.staticPages.gradient.hero,
        borderBottom: 1,
        borderColor: 'staticPages.border.hero',
      }}
      maxWidth={maxWidth}
      innerSx={{
        pt: { xs: 5, md: 7 },
        pb: { xs: 4.5, md: 6 },
        textAlign: centered ? 'center' : 'left',
      }}
    >
      <Typography
        variant="eyebrow"
        sx={{ color: 'staticPages.orange', mb: 1.5 }}
      >
        {eyebrow}
      </Typography>
      <Typography variant="h1" sx={{ mb: 2, color: 'staticPages.navy' }}>
        {title}
      </Typography>
      {subtitle && (
        <Typography
          variant="subtitle1"
          component="p"
          sx={{
            mb: children ? 3 : 0,
            maxWidth: subtitleMaxWidth,
            mx: centered ? 'auto' : undefined,
            color: 'staticPages.text.secondary',
          }}
        >
          {subtitle}
        </Typography>
      )}
      {children}
    </Section>
  );
};

export default PageHero;
